<template>
    <div class="ddmenu divide-y divide-base-200 text-sm rounded-md bg-base shadow-lg ring-1 ring-neutral ring-opacity-5">
        <slot></slot>
    </div>
</template>

<style>
.ddmenu :first-child > a {
	@apply rounded-t-md;
}
.ddmenu :last-child > a {
	@apply rounded-b-md;
}
</style>

<script lang="ts">
export default {}
</script>